module.exports = __webpack_public_path__ + "static/img/4.c725cff.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/4/1/sp/4.png
// module id = 4Vzk
// module chunks = 0